import { createContext } from 'react';

import type { NavigationConfirmationTriggerResult } from '../useNavigationConfirmationTrigger';

export interface NavigationConfirmationEnvironmentCtx {
  subscribeToForm: (formId: string) => void;
  environmentId: string;
  tryNavigatingAway: NavigationConfirmationTriggerResult['tryNavigatingAway'];
  isNavigatingAway: NavigationConfirmationTriggerResult['isNavigatingAway'];
}

const NavigationConfirmationEnvironmentContext =
  createContext<NavigationConfirmationEnvironmentCtx | null>(null);

NavigationConfirmationEnvironmentContext.displayName = 'NavigationConfirmationEnvironmentContext';

export default NavigationConfirmationEnvironmentContext;
